import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import MoreInfo from './MoreInfo/MoreInfo';
import './Promos.css';
import PromosBody from './PromosBody/PromosBody';
import FooterSE from '../components/FooterSE/FooterSE';
import HeaderSE from '../components/HeaderSE/HeaderSE';
import euLadyBackgr1 from '../../assets/eu-lady-background.png';
import euLadyBackgr2 from '../../assets/eu-lady-background2.png';
import clasOhlsonPic from '../../assets/SE/clasohlson-2000-skr.png';
import aplusPic from '../../assets/SE/aplus-5000-skr.png';
import GDPRCookieConsent from '../../components/CookieConsent/GDPRCookieConsent';
import { useTranslation } from '../../locales/useTranslation';

const SEPromos = ({ pageName }) => {
  const { t, translations } = useTranslation('se');
  const [title, setTitle] = useState('Vinn ett presentkort! Registrera dig för att fortsätta!');
  const [headline, setHeadline] = useState('');
  const [picURL, setpicURL] = useState('');
  const [loading, setLoading] = useState(false);
  const [backGr1, setBackgr1] = useState('none');
  const [backGr2, setBackgr2] = useState('none');
  const [textColorDesktop, setTextColorDesktop] = useState('rgb(0, 100, 200)');
  const [textColorMobile, setTextColorMobile] = useState('white');
  const [campaignName, setCampaignName] = useState('SE Clas Ohlson');

  useEffect(() => {
    if (pageName.includes('clasohlson')) {
      setTitle('Vinn presentkort på Clas Ohlson!');
      setHeadline('Vinn presentkort på CLAS OHLSON värt 5 x 2\u00a0000 kr');
      setpicURL(clasOhlsonPic);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('SE Clas Ohlson 2000 kr');
    } else if (pageName.includes('aplus')) {
      setTitle('Vinn ett presentkort!');
      setHeadline('VINN ETT presentkort värt 5\u00a0000 kr för A+ tvättmedelsprodukter');
      setpicURL(aplusPic);
      setBackgr1(euLadyBackgr1);
      setBackgr2(euLadyBackgr2);
      setCampaignName('SE A+ 5000 kr');
    }
  }, [pageName]);

  return (
    <div>
      <HeaderSE />
      <div className="main-container">
        {loading ? (
          <div className="loader-div">
            <h2 id="loading-text">
              {translations?.common?.checkingQualification || 'Kontrollerar om du kvalificerar dig...'}
            </h2>
            <br />
            <br />
            <Loader width="15.5em" height="12.23em" style={{ border: '1px solid black' }} />
          </div>
        ) : (
          <PromosBody
            title={title}
            headline={headline}
            picURL={picURL}
            backgroundPic1={backGr1}
            backgroundPic2={backGr2}
            textColorDesktop={textColorDesktop}
            textColorMobile={textColorMobile}
            campaignName={campaignName}
            translations={translations}
          />
        )}

        <MoreInfo translations={translations} />
      </div>
      <FooterSE translations={translations} />
      <GDPRCookieConsent locale="se" translations={translations} />
    </div>
  );
};

export default SEPromos;
